class ProductBuyBar extends HTMLElement {
  constructor() {
    "use strict";
    super();

    let classes = { show: "show" };
    // Zombie (6 Oct 2026): the cart drawer's upsell cards (hidden) come first in
    // the DOM, so watch the product's own buy-buttons form, not the first .product-form
    let mainProductForm =
      document.querySelector(".section--main-product .product-block__buy_buttons .product-form") ||
      document.querySelector(".product-form");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // In view -> Hide bar
            this.classList.remove(classes.show);
          } else if (window.scrollY > 200) {
            // Out of view AND scrolled a little from top -> Show bar
            this.classList.add(classes.show);
          }
        });
      },
      { threshold: 0.25 }
    );

    observer.observe(mainProductForm);

    // Zombie (18 Oct 2026): the bar has its own <form> holding only the variant
    // id, so it dropped the Appstle Subscribe & Save selling_plan and the main
    // quantity. Hand its submit to the section's MAIN product form instead
    // (#product-form-{section}; the bar's form id is that id + "-product-buy-bar")
    // so Taiga's product-form JS sends the real form: variant, quantity,
    // selling_plan, errors, cart drawer, in-flight guard. No main form -> the
    // bar keeps its own submit.
    this.addEventListener(
      "submit",
      (evt) => {
        const barForm = evt.target;
        // getAttribute: form.id would return the form's <input name="id">
        const barFormId = barForm instanceof HTMLFormElement ? barForm.getAttribute("id") || "" : "";
        if (!barFormId.endsWith("-product-buy-bar")) return;
        const mainForm = document.getElementById(barFormId.replace(/-product-buy-bar$/, ""));
        if (!mainForm || mainForm === barForm || !mainForm.closest("product-form")) return;
        const mainSubmit = mainForm.querySelector('[type="submit"]');
        const canRequest = typeof mainForm.requestSubmit === "function";
        if (!canRequest && !mainSubmit) return;
        evt.preventDefault();
        evt.stopImmediatePropagation();
        if (mainSubmit && mainSubmit.disabled) return;
        if (canRequest) {
          mainForm.requestSubmit(mainSubmit || undefined);
        } else {
          mainSubmit.click();
        }
      },
      true
    );

    // This script is loaded in product-template.liquid --> Footer observer after DOM ready
    document.addEventListener("DOMContentLoaded", function () {
      let siteFooter = document.querySelector("footer.footer");
      if (!siteFooter) return;
      observer.observe(siteFooter);
    });
  }
}
customElements.define("product-buy-bar", ProductBuyBar);

class UpsellCard extends HTMLElement {
  constructor() {
    super();
    this.select = this.querySelector('select');
    this.image = this.querySelector('.card-media img');

    if (this.select) {
      this.select.addEventListener('change', (event) => {
        const selectedOption = event.target.options[event.target.selectedIndex];
        const newImgSrc = selectedOption.getAttribute('data-variant-img-src');
        if (newImgSrc) { this.updateImage(newImgSrc) }
      });
    }
  }

  updateImage(newImgSrc) {
    if (this.image && newImgSrc) {
      // Sanitize and validate URL to prevent XSS
      // Remove any whitespace and HTML entities
      const sanitized = String(newImgSrc).trim().replace(/[\s<>"']/g, '');

      // Reject dangerous protocols (check anywhere in string, not just start)
      const dangerousProtocols = /^(javascript|data|vbscript|file|about):/i;
      if (dangerousProtocols.test(sanitized)) {
        return; // Reject dangerous URLs
      }

      try {
        // Try to parse as absolute URL
        const url = new URL(sanitized, window.location.origin);
        // Only allow http and https protocols
        if (url.protocol === 'http:' || url.protocol === 'https:') {
          // Use the properly constructed URL to prevent any encoding issues
          this.image.src = url.href;
        }
      } catch (e) {
        // If URL parsing fails, it's likely a relative URL
        // Additional validation: ensure it doesn't contain dangerous patterns
        if (!sanitized.includes('javascript:') &&
            !sanitized.includes('data:') &&
            !sanitized.includes('vbscript:') &&
            !sanitized.includes('<') &&
            !sanitized.includes('>')) {
          // For relative URLs, ensure proper encoding
          this.image.src = sanitized;
        }
      }
    }
  }
}

customElements.define('upsell-card', UpsellCard);